import * as allTypes from '../../mutation-type';
import {
  SET_PATRIMOINE_MENU, SET_GESTCOM_MENU, SET_LOGISTIC_MENU,
  SET_COMPTA_MENU, SET_INDEX_SUB_MENU_OPEN, SET_ACTIVE_SUB_MENU,
  SET_BAUX_MENU, SET_ACHAT_MENU, SET_STOCK_MENU,
} from './menu-mutation-type';

function initialState() {
  return {
    patrimoineMenu: false,
    gestcomMenu: false,
    logisticMenu: false,
    comptaMenu: false,
    bauxMenu: false,
    indexSubMenuOpen: null,
    activeSubMenu: null,
    achatMenu: false,
    stockMenu: false,
  };
}

const state = initialState();

const namespaced = true;

const mutations = {
  [SET_PATRIMOINE_MENU](state, patrimoineMenu) {
    state.patrimoineMenu = patrimoineMenu;
    state.gestcomMenu = false;
    state.logisticMenu = false;
    state.comptaMenu = false;
    state.bauxMenu = false;
    state.achatMenu = false;
    state.stockMenu = false;
    state.indexSubMenuOpen = null;
  },
  [SET_GESTCOM_MENU](state, gestcomMenu) {
    state.gestcomMenu = gestcomMenu;
    state.logisticMenu = false;
    state.comptaMenu = false;
    state.patrimoineMenu = false;
    state.bauxMenu = false;
    state.achatMenu = false;
    state.stockMenu = false;
    state.indexSubMenuOpen = null;
  },
  [SET_LOGISTIC_MENU](state, logisticMenu) {
    state.logisticMenu = logisticMenu;
    state.comptaMenu = false;
    state.patrimoineMenu = false;
    state.gestcomMenu = false;
    state.bauxMenu = false;
    state.achatMenu = false;
    state.stockMenu = false;
    state.indexSubMenuOpen = null;
  },
  [SET_COMPTA_MENU](state, comptaMenu) {
    state.comptaMenu = comptaMenu;
    state.patrimoineMenu = false;
    state.gestcomMenu = false;
    state.logisticMenu = false;
    state.bauxMenu = false;
    state.achatMenu = false;
    state.stockMenu = false;
    state.indexSubMenuOpen = null;
  },
  [SET_BAUX_MENU](state, bauxMenu) {
    state.bauxMenu = bauxMenu;
    state.patrimoineMenu = false;
    state.gestcomMenu = false;
    state.logisticMenu = false;
    state.comptaMenu = false;
    state.achatMenu = false;
    state.stockMenu = false;
    state.indexSubMenuOpen = null;
  },
  [SET_ACHAT_MENU](state, achatMenu) {
    state.achatMenu = achatMenu;
    state.patrimoineMenu = false;
    state.gestcomMenu = false;
    state.logisticMenu = false;
    state.bauxMenu = false;
    state.comptaMenu = false;
    state.stockMenu = false;
    state.indexSubMenuOpen = null;
  },
  [SET_STOCK_MENU](state, stockMenu) {
    state.stockMenu = stockMenu;
    state.patrimoineMenu = false;
    state.gestcomMenu = false;
    state.logisticMenu = false;
    state.bauxMenu = false;
    state.comptaMenu = false;
    state.achatMenu = false;
    state.indexSubMenuOpen = null;
  },
  [SET_INDEX_SUB_MENU_OPEN](state, indexSubMenuOpen) {
    state.indexSubMenuOpen = indexSubMenuOpen;
  },
  [SET_ACTIVE_SUB_MENU](state, activeSubMenu) {
    state.activeSubMenu = activeSubMenu;
  },
  [allTypes.RESET_STATE](state) {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
};

const getters = {
  patrimoineMenu: state => {
    return state.patrimoineMenu;
  },
  bauxMenu: state => {
    return state.bauxMenu;
  },
  gestcomMenu: state => {
    return state.gestcomMenu;
  },
  logisticMenu: state => {
    return state.logisticMenu;
  },
  comptaMenu: state => {
    return state.comptaMenu;
  },
  indexSubMenuOpen: state => {
    return state.indexSubMenuOpen;
  },
  activeSubMenu: state => {
    return state.activeSubMenu;
  },
  achatMenu: state => {
    return state.achatMenu;
  },
  stockMenu: state => {
    return state.stockMenu;
  },
};

export default {
  namespaced,
  state,
  mutations,
  getters,
};
